module.exports = __webpack_public_path__ + "static/media/One side Angle's Class II12.380d2f80.png";